import Box from "@/shared/components/common/Box";
import { cn } from "@/shared/libs/commonUtils";

interface HTMLContentServerProps {
  html: TrustedHTML;
  className?: string;
  truncated?: boolean;
}

export function HTMLContentServer({ html, className, truncated }: HTMLContentServerProps) {
  return (
    <Box
      className={cn(
        "html-content-wrapper", 
        truncated && "overflow-hidden max-h-[10rem]",
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
